import {Component,EventEmitter,Input,Output} from '@angular/core';
import {Adresse} from "@domain/profil/adresse";
import {LieuParam} from "@domain/common/lieu/lieu-param";
import {AdresseService} from "@components/lieu/selection/adresse/adresse.service";

/**
 * Composant d'affichage de la liste des adresses
 *
 * @author Lionel Gimenez
 * @date 14/04/2025
 */
@Component({
    host: {'data-test-id': 'adresse-base'},
    selector: 'adresse-base',
    templateUrl: './adresse-base.component.html',
    providers: [AdresseService]
})
export class AdresseBaseComponent {
    /** Paramétrage du lieu */
    @Input() lieuParam: LieuParam;

    /** Event émis lors de la sélection d'une adresse */
    @Output() onAdresseSelect = new EventEmitter<Adresse>();

    /** Liste des adresses pour les lieux OD / OT */
    @Input() listeAdresse: Array<Adresse>;

    /**
     * Constructeur
     */
    constructor(
        public adresseService: AdresseService,
    ) {
    }

    /**
     * Selection d'une adresse dans la liste
     */
    selectAdresse(adresse: Adresse): void {
        this.onAdresseSelect.emit(adresse);
    }
}